/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { SimpleAction } from './simple-action';
import { ITextIcon } from '../../interface/itext-icon';

export class ComboAction<T extends ITextIcon> extends SimpleAction<T> {
  get dataSource(): T[] {
    return this._dataSource;
  }

  set dataSource(value: T[]) {
    this._dataSource = value;
    this.comboValues = value.map((v) => {
      return { check: false, value: v };
    });
    this.checkSelectedData();
  }

  get selectedValues(): T[] {
    return this._selectedValues;
  }

  set selectedValues(value: T[]) {
    this._selectedValues = value;
    this.checkSelectedData();
  }

  /**
   * display the container with items
   */
  public isOpen: boolean;

  public isMultiple: boolean;

  // Combo simple
  public selectedValue: T;

  // Combo multiple
  private _selectedValues: T[] = [];

  private _dataSource: T[];

  public comboValues: { check: boolean; value: T }[] = [];

  public lastChange: { check: boolean; value: T };

  public constructor(
    name: string,
    icon: string,
    placeholder: string,
    dataSource: any,
    value?: any,
    isMultiple?: boolean,
    align?: 'left' | 'center' | 'right'
  ) {
    super(name, icon, dataSource, placeholder);
    this._dataSource = dataSource;
    if (dataSource) {
      dataSource.forEach((item) => {
        this.comboValues.push({ check: false, value: item });
      });
    }
    this.isOpen = false;
    this.isMultiple = isMultiple;
    this.category = 'combo';
    if (align) {
      this.align = align;
    }
    this.value = value;
  }

  /**
   * @deprecated
   * Use category property
   */
  override getActionType(): string {
    return 'combo';
  }

  /**
   * add value in selectedValues
   * it's for multiple comboAction
   * @param value
   */
  addValue(value: T) {
    const item = this._selectedValues.find((a) => a.compare(value) === 0);
    if (item) {
      item.icon = value.icon;
      item.text = value.text;
    } else {
      this._selectedValues.push(value);
    }
  }

  /***
   * remove value in selectedValues
   * it's for multiple comboAction
   * @param value
   */
  removeValue(value: T) {
    const index = this.selectedValues.indexOf(value);
    if (index >= 0) {
      this._selectedValues.splice(index, 1);
    }
  }

  private checkSelectedData() {
    if (this.comboValues && this._selectedValues) {
      for (const cb of this.comboValues) {
        cb.check = !!this._selectedValues.find(
          (v) => v.compare(cb.value) === 0
        );
      }
    }
  }

  switch(item: { check: boolean; value: T }) {
    if (item.check) {
      this.removeValue(item.value);
    } else {
      this.selectedValues.push(item.value);
    }
    this.lastChange = item;
  }
}
